const useReplaceNull = (replacement: string) => {
    return (value?: string | null) => {
        return value ? value : replacement;
    };
};

export default useReplaceNull;
